'use client';

import { AllNewsPage } from '@/components/pages/blog/AllNewsPage';
import { useAppNavigate } from '../_lib/useAppNavigate';
import type { BlogPostDocument, BlogCategoryDocument } from '@/firebase/blog-db';

interface AllNewsClientProps {
  categories: BlogCategoryDocument[];
  posts: BlogPostDocument[];
  hasMore: boolean;
}

export default function AllNewsClient({ categories, posts, hasMore }: AllNewsClientProps) {
  const navigate = useAppNavigate();
  return <AllNewsPage onNavigate={navigate} categories={categories} posts={posts} hasMore={hasMore} />;
}
